export default [
    {
        "id": 457853,
        "node_id": "MDEwOlJlcG9zaXRvcnk0NTc4NTM=",
        "name": "960-Grid-System",
        "full_name": "wesbos/960-Grid-System",
        "private": false,
        "owner": {
            "login": "wesbos",
            "id": 176013,
            "node_id": "MDQ6VXNlcjE3NjAxMw==",
            "avatar_url": "https://avatars.githubusercontent.com/u/176013?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/wesbos",
            "html_url": "https://github.com/wesbos",
            "followers_url": "https://api.github.com/users/wesbos/followers",
            "following_url": "https://api.github.com/users/wesbos/following{/other_user}",
            "gists_url": "https://api.github.com/users/wesbos/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/wesbos/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/wesbos/subscriptions",
            "organizations_url": "https://api.github.com/users/wesbos/orgs",
            "repos_url": "https://api.github.com/users/wesbos/repos",
            "events_url": "https://api.github.com/users/wesbos/events{/privacy}",
            "received_events_url": "https://api.github.com/users/wesbos/received_events",
            "type": "User",
            "site_admin": false
        },
        "html_url": "https://github.com/wesbos/960-Grid-System",
        "description": "The 960 Grid System is an effort to streamline web development workflow.",
        "fork": true,
        "url": "https://api.github.com/repos/wesbos/960-Grid-System",
        "forks_url": "https://api.github.com/repos/wesbos/960-Grid-System/forks",
        "keys_url": "https://api.github.com/repos/wesbos/960-Grid-System/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/wesbos/960-Grid-System/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/wesbos/960-Grid-System/teams",
        "hooks_url": "https://api.github.com/repos/wesbos/960-Grid-System/hooks",
        "issue_events_url": "https://api.github.com/repos/wesbos/960-Grid-System/issues/events{/number}",
        "events_url": "https://api.github.com/repos/wesbos/960-Grid-System/events",
        "assignees_url": "https://api.github.com/repos/wesbos/960-Grid-System/assignees{/user}",
        "branches_url": "https://api.github.com/repos/wesbos/960-Grid-System/branches{/branch}",
        "tags_url": "https://api.github.com/repos/wesbos/960-Grid-System/tags",
        "blobs_url": "https://api.github.com/repos/wesbos/960-Grid-System/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/wesbos/960-Grid-System/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/wesbos/960-Grid-System/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/wesbos/960-Grid-System/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/wesbos/960-Grid-System/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/wesbos/960-Grid-System/languages",
        "stargazers_url": "https://api.github.com/repos/wesbos/960-Grid-System/stargazers",
        "contributors_url": "https://api.github.com/repos/wesbos/960-Grid-System/contributors",
        "subscribers_url": "https://api.github.com/repos/wesbos/960-Grid-System/subscribers",
        "subscription_url": "https://api.github.com/repos/wesbos/960-Grid-System/subscription",
        "commits_url": "https://api.github.com/repos/wesbos/960-Grid-System/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/wesbos/960-Grid-System/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/wesbos/960-Grid-System/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/wesbos/960-Grid-System/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/wesbos/960-Grid-System/contents/{+path}",
        "compare_url": "https://api.github.com/repos/wesbos/960-Grid-System/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/wesbos/960-Grid-System/merges",
        "archive_url": "https://api.github.com/repos/wesbos/960-Grid-System/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/wesbos/960-Grid-System/downloads",
        "issues_url": "https://api.github.com/repos/wesbos/960-Grid-System/issues{/number}",
        "pulls_url": "https://api.github.com/repos/wesbos/960-Grid-System/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/wesbos/960-Grid-System/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/wesbos/960-Grid-System/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/wesbos/960-Grid-System/labels{/name}",
        "releases_url": "https://api.github.com/repos/wesbos/960-Grid-System/releases{/id}",
        "deployments_url": "https://api.github.com/repos/wesbos/960-Grid-System/deployments",
        "created_at": "2010-01-04T10:12:23Z",
        "updated_at": "2022-11-20T20:24:03Z",
        "pushed_at": "2009-12-20T16:26:58Z",
        "git_url": "git://github.com/wesbos/960-Grid-System.git",
        "ssh_url": "git@github.com:wesbos/960-Grid-System.git",
        "clone_url": "https://github.com/wesbos/960-Grid-System.git",
        "svn_url": "https://github.com/wesbos/960-Grid-System",
        "homepage": "http://960.gs/",
        "size": 347,
        "stargazers_count": 5,
        "watchers_count": 5,
        "language": null,
        "has_issues": false,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "has_discussions": false,
        "forks_count": 4,
        "mirror_url": null,
        "archived": false,
        "disabled": false,
        "open_issues_count": 0,
        "license": null,
        "allow_forking": true,
        "is_template": false,
        "web_commit_signoff_required": false,
        "topics": [],
        "visibility": "public",
        "forks": 4,
        "open_issues": 0,
        "watchers": 5,
        "default_branch": "master"
    }]